'use strict';

var _toConsumableArray = require("/builds/accutrainee/admin-react/react/candidate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var mapping = {};

var splitWithSpace = function splitWithSpace(s) {
  return s ? s.split(' ') : [];
};

var toArray = function toArray(a) {
  return Array.isArray(a) ? a : [a];
};

function parseTokens(tokens) {
  tokens.forEach(function (token) {
    if (/(_open$|image)/.test(token.type) && mapping[token.tag]) {
      var orig = splitWithSpace(token.attrGet('class'));
      var addition = toArray(mapping[token.tag]);
      token.attrSet('class', [].concat(_toConsumableArray(orig), _toConsumableArray(addition)).join(' '));
    }

    if (token.children) {
      parseTokens(token.children);
    }
  });
}

function parseState(state) {
  parseTokens(state.tokens);
}

function markdownitTagToClass(md, _mapping) {
  mapping = _mapping || {};
  md.core.ruler.push('markdownit-tag-to-class', parseState);
}

module.exports = markdownitTagToClass;